import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { CheckActionPermission } from "../../../Actions/commonAction";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import TabContainer from "../../../Component/Common/TabContainer";
import ReportHistory from "./ReportHistory";
import ReportRobo from "./ReportRobo";
import ScheduledReport from "./ScheduledReport";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      id: null,
      actionidList: "",
      disableTab: true,
      permissions: { readOnly: false, editable: false },
    };
  }

  handleChange = (event, value, id) => {
    let requeststatusid;
    this.setState({ value, id }, () => {});
  };

  componentWillMount() {
    this.props.ChangeLanguage("reportrobo,navigation");
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("reportRobo");
    if (isTrue) {
      this.setState({ permissions }, () => {
        if (this.state.permissions.editable) {
          this.setState({ value: 0, disableTab: false });
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillReceiveProps(props) {}

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    const language = this.props.Language.reportrobo;
    return (
      <IntlProvider locale="en" messages={language}>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div className="innerwrapper-full-width">
            <div className="common-menubar-header">
              <Tabs
                value={value}
                onChange={this.handleChange}
                indicatorColor="#fff"
                textColor="primary"
                scrollButtons="auto"
              >
                <Tab
                  label={<FormattedMessage id="LbRobo" defaultMessage="Robo" />}
                  disabled={this.state.disableTab}
                  className={` ${
                    this.state.value == 0 ? "active-tab1" : "inactive-tab1"
                  } `}
                />
                <Tab
                  label={
                    <FormattedMessage
                      id="LbScheduledReports"
                      defaultMessage="Scheduled Reports"
                    />
                  }
                  className={` ${
                    this.state.value == 1 ? "active-tab1" : "inactive-tab1"
                  } `}
                />
                <Tab
                  label={
                    <FormattedMessage
                      id="LbReportHistory"
                      defaultMessage="Report History"
                    />
                  }
                  className={` ${
                    this.state.value == 2 ? "active-tab1" : "inactive-tab1"
                  } `}
                />
              </Tabs>
              <div className="tab-border"></div>
            </div>

            <main className="content-outer-wrapper-with-tab">
              <div className={classes.root}>
                {value === 0 && (
                  <TabContainer>
                    <ReportRobo
                      permissions={this.state.permissions}
                      {...this.props}
                      updateId={this.state.id}
                      handleChange={this.handleChange.bind(this)}
                    />
                    {/* <AutoRequest
                                {...this.props}
                                requeststatusid={this.state.requeststatusid} /> */}
                  </TabContainer>
                )}
                {value === 1 && (
                  <TabContainer>
                    <ScheduledReport
                      permissions={this.state.permissions}
                      handleChange={this.handleChange.bind(this)}
                      {...this.props}
                    />
                    {/* <AutoRequest
                                {...this.props}
                                requeststatusid={this.state.requeststatusid} /> */}
                  </TabContainer>
                )}
                {value === 2 && (
                  <TabContainer>
                    <ReportHistory />
                  </TabContainer>
                )}
              </div>
            </main>
          </div>
        )}
      </IntlProvider>
    );
  }
}

Report.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Report)));

// export default withStyles(styles)(Report);
